import type { TAPISource } from '../../../types/tracking'
import { StatusIcon } from '../status-icon'

interface IAPITooltip {
  trackingSourceData: TAPISource
}

/**
 * The component that displays the API tracking info in a tooltip
 */
export const APITooltip = (props: IAPITooltip) => {
  const { trackingSourceData } = props
  const isTracking = Boolean(trackingSourceData.locations?.length)

  return (
    <div className="p-4">
      <div className="flex w-full flex-col space-y-2">
        <p className="text-md font-semibold">
          This data is being sent by {trackingSourceData?.source || 'the carrier'} through API
        </p>

        <div className="flex items-center space-x-2">
          <StatusIcon isPositive={isTracking} />
          <span>Status: {isTracking ? 'Tracking' : 'Not tracking'}</span>
        </div>
      </div>
    </div>
  )
}
